<template>
  <div class="changFontSize">
    <div class="_title">字体大小：</div>
    <div class="_item">
      <span @click="changFontSize(20)" v-if="props.defaultSize">大</span>
      <span @click="changFontSize(18)" v-if="props.defaultSize">中</span>
      <span @click="changFontSize(16)" v-if="props.defaultSize">小</span>
<!--      使用插槽时，请在引入地方使用useChangeFontSize.js 方法-->
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import useChangeFontSize from "../hooks/useChangeFontSize";

const props = defineProps({
  // 要改变文本大小的dom id
  domId: {
    type: String,
    required: true
  },
  // 是否显示默认大中小三个数值
  defaultSize: {
    type: Boolean,
    required: false,
    default: true,
  }
})

const { changFontSize } = useChangeFontSize(props.domId)
</script>

<style scoped lang="scss">
.changFontSize {
  // align-items: center;
  text-align: right;
  font-size: 18px;
  > ._title {
  color: var(--secondary-text-color);
  display: inline-block;
  }
  > ._item {
    color: var(--main-blue-color);
    display: inline-block;
    cursor: pointer;
    > span {
      margin-right: 5px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
